import React, { FC } from 'react';

export interface ClarityNumberReportProps {
    data: Array<any>;
}

export const ClarityNumberReport: FC<ClarityNumberReportProps> = data => {
    return <div style={{ fontSize: '32px' }}>{data.data}</div>;
};
